export const environment = {
    production: true,
    apiUrl: 'https://api-admin.latipay.net/',
    apiParaUrl: 'https://parasite.latipay.net/',
    merchantUrl: 'https://merchant.latipay.net',
    ticketUrl: 'https://ticket.latipay.net',
    key: 'B0v13W9lp1O9GXS'
};
